import React, { ReactNode } from "react";
import styles from "../../styles/navbar.module.css";

interface Props {
  children: ReactNode;
}

const Branding: React.FC<Props> = ({ children }) => {
  return (
    <div
      className={styles.branding}
    >
      {children}
    </div>
  );
};

export default Branding;
